import _ from 'lodash';
import history from 'config/history';

import { CONNECT_LOGIN_URL } from 'global-constants';
import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

export const getFinalStepText = ({ defaultText }) => {
  const nextURL = buildUrlFromNextRedirect(history.location.search);

  if (_.isNil(nextURL)) {
    return defaultText;
  }

  if (_.includes(nextURL, CONNECT_LOGIN_URL)) {
    return 'Continue to RE:Connect';
  }

  return 'Continue';
};
